import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Container, Typography } from '@mui/material'
import { IPOrganismosFilter, IPOrganismosTable } from '../../../../features/ip-organismos'

export const IPOrganismosDashboardPage = () => {
  const { formatMessage } = useIntl()

  return (
    <Container maxWidth={false} sx={{ py: 3 }}>
      <Box mb={2}>
        <Typography variant="h4" color="textSecondary">
          {formatMessage({ id: 'pages.ip.dashboard.title' })}
        </Typography>
      </Box>
      <Box mb={2} display="flex">
        <IPOrganismosFilter />
      </Box>
      <Box>
        <IPOrganismosTable />
      </Box>
    </Container>
  )
}
